// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/javascripts/single_work/index.js
// MAGIC_DESPROCKET_END
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
if (window.Aedu == null) {
  window.Aedu = {};
}
window.Aedu.SingleWork = {};
window.SingleWork = {
  preview_controller: null, // set in preview_controller.js

  register_preview_view(identifier, view) {
    return this.preview_controller.register_view(identifier, view);
  },

  show_preview(identifier) {
    return this.preview_controller.show(identifier);
  },
};
